import { useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { X, AlertCircle, ShieldCheck } from 'lucide-react';
import { msoSyllabus, msoExamDetails } from '../data/msoData';
import { mcooSyllabus, mcooExamDetails } from '../data/mcooData';
import { universalData } from '../data/universalData';
import './Olympiads.css';
import fpPromise from '@fingerprintjs/fingerprintjs';
import { useRegistrationStore } from '../store/useRegistrationStore';
import { Helmet } from 'react-helmet-async';
import { load } from '@cashfreepayments/cashfree-js';

const MATHURA_SCHOOLS = [
  "ABS Public School, Village Kurkanda, Farah, Mathura",
  "Adarsh Vidya Mandir, Kosi Kalan, Mathura",
  "Amar Nath Vidya Ashram Senior Secondary School, Mathura",
  "Angel Public School, Ranwari, NH-2, Chhata, Mathura",
  "Arcadian Public School, Nauhjheel, Bajna, Mathura",
  "Army Public School, Mathura Cantt",
  "Ashoka Intellects Global School, Mathura",
  "BBR International School, Runchit, Township, Mathura",
  "B.G.B. Braj Education Academy, Mahawan, Mathura",
  "Baba Kadhera Singh Vidya Mandir, Akkha, Mathura",
  "Baba Patiram Vidya Mandir High School, Palikhera, Mathura",
  "Baldeo Public School, Kailash Road, Mathura",
  "BDA Saraswati Vidya Mandir, Maholi, Mathura",
  "Brij Dham Vidya Mandir, Village Pali Dungra, Mathura",
  "BS Academy, Village & PO Tenti Gaon, Maant, Mathura",
  "C.L.A. Public School, Bajna, Mant, Mathura",
  "Ch. Arjun Singh Public School, Shergarh, Mathura",
  "Ch. Narottam Singh International School, Garhi Ashiya, Mathura",
  "Chandanvan Public School, Bharatpur Road, Mathura",
  "Charkula Global Public School, Radhakund, Mathura",
  "Chetan International School, Vidavani, Sonai, Mathura",
  "Crescent Convent Senior Secondary School, 72 Golf Road, Mathura",
  "CSRV Vidya Ashram, Chaumuhan, Mathura",
  "DRSS Modern School, Shergarh, Chhata, Mathura",
  "Delhi Public School, NH-2, Akbarpur, Chhata, Mathura",
  "Delhi Public School, Rasoolpur, Magorra, Mathura",
  "Delhi Public School, Refinery Nagar, Mathura",
  "Delhi World Public School, Kosikalan, Mathura",
  "Dr. R M Saha Global School, Chhatikara, Mathura",
  "Elite New Gen International School, Saraswati Kund, Mathura",
  "GS Bharti Senior Secondary School, Goverdhan Road, Mathura",
  "Ganga Devi Vidya Niketan, Barsana, Mathura",
  "Goverdhan Vidyapeeth, Om Nagar, Padal, Mathura",
  "Green Willow Public School, Navada, Mathura",
  "Harish Raghav Public School, Naugaon, Mathura",
  "Heera Singh Public School, Ading Sonkh Road, Mathura",
  "Heritage Public School, Mathura",
  "HPDS Balika Vidya Mandir, Vrindawan, Mathura",
  "JSM Educational Academy, Mant, Mathura",
  "Jag International Junior High School, Narholi, PO Aduki, Mathura",
  "Jawahar Navodaya Vidyalaya, Mathura",
  "JSB Public School, Kosi Khurd Sadar, Mathura",
  "KD Public School, Neem Gaon Road, Ayra Khera, Mathura",
  "KN International School, Bharatpur Road, Mathura",
  "KRSD Public School, Raipur Lohavan, Mahavan, Mathura",
  "Kanha Makhan Millennium School, Agravatika, Mathura",
  "Kanha Makhan Millennium School, Omexe, Vrindavan",
  "Kanha Makhan Public School, Jaigurudev, Mathura",
  "Kanha Makhan Public School, Kosikalan, Mathura",
  "Kanha Makhan Public School, Moholi Road, Mathura",
  "Kanha Makhan Public School, Saraswati Kund, Masani, Mathura",
  "Kanha Makhan Public School, Tehra Link Road, Vrindavan",
  "Kanha Makhan Public School Township, Baad, Mathura",
  "KDS International School, Salempur Road, Mathura",
  "Kendriya Vidyalaya, Baad, Mathura",
  "Kendriya Vidyalaya, Mathura Cantt",
  "Kendriya Vidyalaya, Mathura Refinery, Mathura",
  "Krishnakulam, Village Koyal Raya, Mathura",
  "M D Jain Public School, Kosi Kalan, Mathura",
  "Madan Mohan Kalawati Sarraf Saraswati Vidhya Mandir, Chanravali, Mathura",
  "MPSM Grace Convent School, Village Ganeshra, Mathura",
  "Maa Santoshi Vidhya Mandir JHS, Adeeg, Mathura",
  "Mathura Public School, Gausana Raya Road, Mathura",
  "Modern Academy International, Kosi Kalan, Mathura",
  "Mount Hill Academy, Ajay Nagar, Mahavan, Mathura",
  "Mount Hill Academy, Chandanvan, Mathura",
  "Mount Litera Zee School, Delhi Masani Road, Mathura",
  "Murari Kunj SVM, Danghati, Goverdhan, Mathura",
  "New Imperial Public School, Edal Garhi, Mathura",
  "Nibodhita Vidya Mandir, Village Goverdhan, Mathura",
  "Nishkalanka Mata School, Village & PO Jait, Mathura",
  "PDDS Vidya Mandir, Vrindaban, Mathura",
  "PDU SVM Inter College, Post Farah, Mathura",
  "Parvati Radhakishen Fomra School, Village Khamni, Mathura",
  "Police Modern School, Reserve Police Lines, Mathura",
  "Porter Burchard Methodist School, Vrindavan, Mathura",
  "Prasad Public School, Industrial Area, Mathura",
  "PTHSR Indian Public School, Vrindavan, Mathura",
  "RLPKD Vidya Mandir, Goverdhan Road, Mathura",
  "RMVN Junior High School, Village & Post Mant Raja, Mathura",
  "Rajiv International School, Chhatikara, Mathura",
  "Ramanlal Shorawala International School, Rawal, Mathura",
  "Ramanlal Shorawala Public School, Mathura",
  "Rishikul International School, Mahavan, Mathura",
  "RK International School, VPO Paigaon, Chhata",
  "Romex International School, NH-2, Mathura",
  "SD Public School, Nandgaon, Chhata, Mathura",
  "SKS Public School, Bulakpur, Meerpur, Mathura",
  "SRR Public School, Sanket Nandgaon, Barsana Road, Mathura",
  "SSD Public School, Sadabad Road, Raya, Mathura",
  "S Vidya Mandir, Keshav Nagar, Vrindavan, Mathura",
  "S. Tagore Academy Public School, Mahuvan, Farah, Mathura",
  "Samvid Gurukulam, Vatsalya Gram, Mathura",
  "Sanjay Public School, NH-2, Chaumuhan, Mathura",
  "Sanskar Public School, Mahaoli Road, Mathura",
  "Sanskriti Public School, Baldev, Mathura",
  "Saraswati Vidya Mandir, Chhata, Mathura",
  "Saraswati Vidya Mandir, Kosikalan, Mathura",
  "Shri Balaji Public School, Avairni, Mathura",
  "Shri Girraj Maharaj Global Public School, Mathura",
  "Shri International School, Barsana Road, Chhata, Mathura",
  "Shri Krishnam Public School, Goverdhan, Mathura",
  "Shriji Baba Saraswati Vidya Mandir, Mathura",
  "Smt. Anguri Devi Public School, Hulwana, Chhata, Mathura",
  "Sophia Public School, Chikada, Sadabad Road, Mathura",
  "SPS International Academy, NH-2, Kosi Kalan, Mathura",
  "SRBS International School, Nauhjeel, Mant, Mathura",
  "SRS International School, Village Mudilia, PO Bajna, Mathura",
  "St. Dominic's School, Basantar Marg, Mathura Cantt",
  "St. Paul's School, Chandrapuri Colony, Mathura",
  "Sunrise Public School, Bati Bajna Road, Sajna, Mathura",
  "SVS International School",
  "Symbiosis School for Excellence, Salempur, Mathura",
  "The Millennium School, Mauja Govindpur, Mathura",
  "Vatsalya Public School, Goverdhan, Mathura",
  "Ved Prakash Pathak Public School, Naujheel, Mathura",
  "Vidya Devi Jindal School, Kosi Kalan, Mathura",
  "Vidya Sagar Academy, Mant Road, Raya, Mathura",
  "Vrindavan Public School, Dhorera, Premnagar, Mathura",
  "Other"
];

export default function Olympiads() {
  const [selectedOly, setSelectedOly] = useState(null);
  const [activeTab, setActiveTab] = useState('participate');
  const [selectedClass, setSelectedClass] = useState(7);
  const [deviceId, setDeviceId] = useState('');

  // Registration Form State (Zustand Persisted)
    const [paymentStatus, setPaymentStatus] = useState({ show: false, success: false, txnid: '' });
  const { formData, updateFormData, resetForm, idempotencyKey } = useRegistrationStore();
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [showGatewaySelector, setShowGatewaySelector] = useState(false);

  useEffect(() => {
    // Generate device fingerprint
    (async () => {
      try {
        const fp = await fpPromise.load();
        const result = await fp.get();
        setDeviceId(result.visitorId);
      } catch (_err) {
        setDeviceId('fallback-' + Date.now());
      }
    })();

    // Load Razorpay Script dynamically
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get('status');
    const txnid = params.get('txnid');
    const order_id = params.get('order_id');
    const gateway = params.get('gateway');
    
    if (gateway === 'cashfree' && order_id) {
      // Cashfree redirect return handling
      fetch('/api/verify-payment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gateway: 'cashfree', cashfree_order_id: order_id })
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setPaymentStatus({ show: true, success: true, txnid: order_id });
            resetForm();
          } else {
            setPaymentStatus({ show: true, success: false, txnid: '' });
            useRegistrationStore.getState().regenerateIdempotencyKey();
          }
        })
        .catch(() => {
          setPaymentStatus({ show: true, success: false, txnid: '' });
          useRegistrationStore.getState().regenerateIdempotencyKey();
        });
        
      window.history.replaceState({}, document.title, window.location.pathname);
    } else if (status) {
      // Legacy / other gateways status-based returns
      const isSuccess = status === 'success' || status === 'PAID' || status === 'SUCCESS';
      const isFailed = status === 'failed' || status === 'EXPIRED' || status === 'TERMINATED' || status === 'FAILED';
      
      // eslint-disable-next-line react/set-state-in-effect
      setPaymentStatus({ show: true, success: isSuccess, txnid: txnid || '' });
      if (isSuccess) {
          resetForm();
      } else if (isFailed) {
          useRegistrationStore.getState().regenerateIdempotencyKey();
      }
      
      // Remove params from URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [olympiadDetails, setOlympiadDetails] = useState([]);
  const [loadingOlympiads, setLoadingOlympiads] = useState(true);

  useEffect(() => {
    fetch('/api/cms/olympiads')
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          const mapped = data.map(oly => {
            const match = oly.name.match(/(.+)\s\((.+)\)/);
            const titleMatch = match ? match[2] : '';
            const id = titleMatch ? titleMatch.toLowerCase() : `oly_${oly.id}`;
            return {
              id: id,
              title: oly.name,
              desc: oly.description,
              classes: oly.classes,
              eligibility: oly.eligibility,
              syllabus: oly.syllabus,
              exam_details: oly.exam_details,
              logo_data: oly.logo_data,
              isOpen: oly.name.includes('Mathura Science Olympiad')
            };
          });
          const sorted = mapped.sort((a, b) => (b.isOpen ? 1 : 0) - (a.isOpen ? 1 : 0));
          setOlympiadDetails(sorted);

          // Auto-open modal if ?exam=... is present in URL
          const params = new URLSearchParams(window.location.search);
          const examParam = params.get('exam');
          if (examParam) {
            const targetOly = mapped.find(o => o.id === examParam.toLowerCase());
            if (targetOly) {
              setSelectedOly(targetOly);
              setActiveTab('participate');
              setSelectedClass(targetOly.id === 'mcoo' ? 11 : 7);
              // Clean up URL so it doesn't reopen if they close and refresh
              window.history.replaceState({}, document.title, window.location.pathname);
            }
          }
        }
      })
      .catch(console.error)
      .finally(() => setLoadingOlympiads(false));
  }, []);

  const openModal = (oly, tab) => {
    setSelectedOly(oly);
    setActiveTab(tab);
    setSelectedClass(oly.id === 'mcoo' ? 11 : 7); // reset to class 7 or 11
    // Reset form state when reopening
    setIsSubmitted(false);
    setError(null);
  };

  const closeModal = () => {
    setSelectedOly(null);
    setIsSubmitted(false);
    setError(null);
    setShowGatewaySelector(false);
  };

  const tabs = [
    { id: 'participate', label: 'How to participate' },
    { id: 'eligibility', label: 'Eligibility' },
    { id: 'syllabus', label: 'Syllabus' },
    { id: 'exam-details', label: 'Exam Details' },
    { id: 'awards', label: 'Awards & Deliverables' }
  ];

  const handleProceedToRegistration = () => {
    // 🚀 GOD MODE: Zero-Allocation Tracking + Zero-Loss Transport
    // Bypasses JSON parsing on backend (GET) while guaranteeing OS delivery on tab close (keepalive).
    fetch(`/api/analytics/track?event=registration_click&t=${Date.now()}`, { method: 'GET', keepalive: true }).catch(() => {});
    setActiveTab('register');
  };

  const handleChange = (e) => {
    updateFormData({ [e.target.id]: e.target.value });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.firstName || !formData.lastName || !formData.email || !formData.phone || !formData.classGrade || !formData.schoolName) {
      setError('Please fill in all the mandatory fields.');
      return;
    }

    if (formData.schoolName === 'Other' && !formData.customSchoolName) {
      setError('Please enter your school name.');
      return;
    }

    if (!captchaVerified) {
      setError('Please complete the CAPTCHA verification.');
      return;
    }

    setError(null);
    setShowGatewaySelector(true);
  };

  const verifyPayment = async (gateway, txnid) => {
    try {
      const res = await fetch('/api/verify-payment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gateway, cashfree_order_id: txnid })
      });
      const data = await res.json();
      if (data.success) {
        setPaymentStatus({ show: true, success: true, txnid });
        resetForm();
      } else {
        setPaymentStatus({ show: true, success: false, txnid: '' });
        useRegistrationStore.getState().regenerateIdempotencyKey();
      }
    } catch (_err) {
      setPaymentStatus({ show: true, success: false, txnid: '' });
      useRegistrationStore.getState().regenerateIdempotencyKey();
    } finally {
      setIsSubmitting(false);
    }
  };

  const processPayment = async (gateway) => {
    try {
      setIsSubmitting(true);
      setError(''); // Clear any previous errors
      setShowGatewaySelector(false); // Hide the gateway selector

      const response = await fetch('/api/create-order', {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'idempotency-key': idempotencyKey
        },
        body: JSON.stringify({ 
           amount: 125,
           gateway,
           formData: {
               firstName: formData.firstName,
               lastName: formData.lastName,
               email: formData.email,
               phone: formData.phone,
               schoolName: formData.schoolName === 'Other' ? formData.customSchoolName : formData.schoolName,
               classGrade: formData.classGrade
           },
           olympiad: selectedOly.title,
           captchaToken: formData.captchaToken,
           website_url: formData.website_url,
           deviceId,
           idempotencyKey
        })
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        const msg = errData.error || errData.errors?.[0]?.msg || 'Failed to create order';
        throw new Error(msg);
      }

      const orderData = await response.json();
      
      if (orderData.success && orderData.gateway === 'cashfree') {
          let checkoutOptions = {
              paymentSessionId: orderData.payment_session_id,
              redirectTarget: "_self"
          };
          
          try {
              const cashfree = await load({ mode: "production" });
              if (!cashfree) {
                  throw new Error("Cashfree SDK failed to load");
              }
              cashfree.checkout(checkoutOptions).then((result) => {
                  if (result && result.error) {
                      console.error("Cashfree checkout error/closed:", result.error);
                      setError(result.error.message || "Payment cancelled or failed.");
                      setIsSubmitting(false);
                      useRegistrationStore.getState().regenerateIdempotencyKey();
                  }
                  if (result && result.paymentDetails) {
                      console.log("Payment completed successfully:", result.paymentDetails);
                      verifyPayment('cashfree', result.paymentDetails.paymentMessage || orderData.order_id);
                  }
              }).catch((err) => {
                  console.error("Cashfree checkout promise rejected:", err);
                  setError("Payment gateway failed to initialize. Please try again.");
                  setIsSubmitting(false);
                  useRegistrationStore.getState().regenerateIdempotencyKey();
              });
          } catch (syncErr) {
              console.error("Cashfree sync/load error:", syncErr);
              setError("Internal Error: Could not load Cashfree. Please try Razorpay.");
              setIsSubmitting(false);
              useRegistrationStore.getState().regenerateIdempotencyKey();
          }
      } else if (orderData.success && orderData.gateway === 'razorpay') {
         if (typeof window.Razorpay === 'undefined') {
             setIsSubmitting(false);
             useRegistrationStore.getState().regenerateIdempotencyKey();
             setError('Payment system is blocked by your browser. Please disable any Ad-Blockers (like uBlock) or Brave Shields and try again.');
             return;
         }

         // Open Razorpay Checkout
         const options = {
           key: import.meta.env.VITE_RAZORPAY_KEY_ID,
           amount: orderData.amount,
           currency: orderData.currency,
           name: "Dynamic Exams",
           description: selectedOly.title + " Registration",
           order_id: orderData.order_id,
           handler: async function (response) {
             // Verify Payment
             try {
               const verifyRes = await fetch('/api/verify-payment', {
                 method: 'POST',
                 headers: { 'Content-Type': 'application/json' },
                 body: JSON.stringify({
                   razorpay_order_id: response.razorpay_order_id,
                   razorpay_payment_id: response.razorpay_payment_id,
                   razorpay_signature: response.razorpay_signature,
                   gateway: 'razorpay'
                 })
               });
               
               const verifyData = await verifyRes.json();
               if (verifyData.success) {
                 setPaymentStatus({ show: true, success: true, txnid: response.razorpay_payment_id });
                 resetForm();
               } else {
                 setPaymentStatus({ show: true, success: false, txnid: '' });
                 useRegistrationStore.getState().regenerateIdempotencyKey();
               }
             } catch (err) {
               console.error("Verification failed", err);
               setPaymentStatus({ show: true, success: false, txnid: '' });
               useRegistrationStore.getState().regenerateIdempotencyKey();
             }
             setIsSubmitting(false);
           },
           prefill: {
             name: formData.firstName + ' ' + formData.lastName,
             email: formData.email,
             contact: formData.phone
           },
           theme: {
             color: "#1d4ed8"
           },
           modal: {
             ondismiss: function() {
               setIsSubmitting(false);
               useRegistrationStore.getState().regenerateIdempotencyKey();
             }
           }
         };
         
         const rzp = new window.Razorpay(options);
         rzp.on('payment.failed', function (_response){
             setPaymentStatus({ show: true, success: false, txnid: '' });
             setIsSubmitting(false);
             useRegistrationStore.getState().regenerateIdempotencyKey();
         });
         rzp.open();
      } else {
         useRegistrationStore.getState().regenerateIdempotencyKey();
         setError('Payment initiation failed');
         setIsSubmitting(false);
      }
    } catch (err) {
      console.error('Payment Error:', err);
      useRegistrationStore.getState().regenerateIdempotencyKey();
      if (err.message === 'Failed to fetch') {
         setError('Server error. Ensure the backend server is running.');
      } else {
         setError(err.message || 'Payment initiation failed. Please try again.');
      }
      setIsSubmitting(false);
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "item": {
          "@type": "EducationalOccupationalProgram",
          "name": "Mathura Science Olympiad",
          "provider": {
            "@type": "EducationalOrganization",
            "name": "Dynamic Exams"
          }
        }
      },
      {
        "@type": "ListItem",
        "position": 2,
        "item": {
          "@type": "EducationalOccupationalProgram",
          "name": "Mathura Commerce Olympiad",
          "provider": {
            "@type": "EducationalOrganization",
            "name": "Dynamic Exams"
          }
        }
      }
    ]
  };

  return (
    <div className="olympiads-page">
      <Helmet>
        <title>Olympiads | Dynamic Exams</title>
        <meta name="description" content="Explore our upcoming Olympiads, including the Mathura Science Olympiad and Mathura Commerce Olympiad. Find syllabuses, exam details, and register today." />
        <meta property="og:title" content="Olympiads | Dynamic Exams" />
        <meta property="og:description" content="Explore and register for upcoming Olympiads." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dynamicexams.org/olympiads" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
            {paymentStatus.show && (
        <div style={{ backgroundColor: paymentStatus.success ? '#d4edda' : '#f8d7da', color: paymentStatus.success ? '#155724' : '#721c24', padding: '15px', textAlign: 'center', fontWeight: 'bold' }}>
           {paymentStatus.success 
                ? `Payment Successful! Transaction ID: ${paymentStatus.txnid}. You will receive a confirmation email shortly.` 
               : 'Payment Failed or Cancelled. Please try again.'}
           <button onClick={() => setPaymentStatus({ show: false })} style={{ marginLeft: '15px', background: 'transparent', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>X</button>
        </div>
      )}
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">Our Olympiads</h1>
        </div>
      </div>

      <section className="section-padding">
        <div className="container">
          {loadingOlympiads ? (
            <div className="olympiads-list-placeholder" style={{ minHeight: '80vh' }}></div>
          ) : (
            <div className="olympiads-list" style={{ minHeight: '80vh' }}>
              {olympiadDetails.map((oly) => (
                <div key={oly.id} className="oly-detail-card glass-panel">
                  <div className="oly-detail-header" style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    {oly.logo_data ? (
                      <img src={oly.logo_data} alt={`${oly.title} Logo`} loading="lazy" width="80" height="80" style={{ height: '80px', width: '80px', objectFit: 'contain', borderRadius: '8px' }} />
                    ) : (
                      <img src={`/logos/${oly.id}.webp`} alt={`${oly.id.toUpperCase()} Logo`} loading="lazy" width="140" height="140" style={{ height: '140px', width: '140px', objectFit: 'contain' }} onError={(e) => e.target.style.display='none'} />
                    )}
                    <h2 style={{ margin: 0, flex: 1, minWidth: '200px' }}>{oly.title}</h2>
                  </div>
                  <p className="oly-desc">{oly.desc}</p>
  
                  <div className="oly-info-links">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        className="info-link-btn"
                        onClick={() => openModal(oly, tab.id)}
                      >
                        {tab.label}
                      </button>
                    ))}
                  </div>
  
                  <div className="oly-actions mt-4">
                    {oly.isOpen ? (
                      <button className="btn btn-primary" onClick={() => openModal(oly, 'register')}>Register Now</button>
                    ) : (
                      <button className="btn btn-primary" disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>Coming Soon</button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Modal */}
      {selectedOly && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content glass-panel" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{selectedOly.title}</h3>
              <button className="close-btn" onClick={closeModal}><X size={24} /></button>
            </div>

            <div className="modal-tabs">
              {tabs.map(tab => (
                <button
                  key={tab.id}
                  className={`modal-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="modal-body" style={{ maxHeight: '60svh', overflowY: 'auto', padding: '1rem' }}>
              {isSubmitted ? (
                <div className="success-state" style={{ textAlign: 'center', padding: '2rem' }}>
                  <ShieldCheck size={64} color="var(--secondary-gold)" style={{ margin: '0 auto 1rem', display: 'inline-block' }} />
                  <h3>Registration Successful!</h3>
                  <p>Thank you for registering for {selectedOly.title}. We have sent a confirmation to your email.</p>
                  <button className="btn btn-outline" onClick={closeModal} style={{ marginTop: '1rem' }}>Close</button>
                </div>
              ) : (
                <>
                  {activeTab === 'participate' && (
                    <div className="tab-pane">
                      <h4>How to participate</h4>
                      <p>{universalData.howToParticipate}</p>
                    </div>
                  )}

                  {activeTab === 'eligibility' && (
                    <div className="tab-pane">
                      <h4>Eligibility</h4>
                        <>
                          <p><strong>Stage I:</strong> {universalData.eligibility.stage1}</p>
                          <p><strong>Stage II:</strong> {universalData.eligibility.stage2}</p>
                          <p style={{ marginTop: '1rem', fontStyle: 'italic' }}>
                            {universalData.eligibility.specifics[selectedOly?.id] || "This Olympiad is open to students of specified classes."}
                          </p>
                        </>
                    </div>
                  )}

                  {activeTab === 'syllabus' && (
                    <div className="tab-pane">
                      <h4>Syllabus</h4>
                      {selectedOly.id === 'mso' || selectedOly.id === 'mcoo' ? (
                        <>
                          <div className="class-selector mb-4">
                            {Object.keys(selectedOly.id === 'mso' ? msoSyllabus : mcooSyllabus).map(cls => (
                              <button
                                key={cls}
                                className={`class-btn ${selectedClass === parseInt(cls) ? 'active' : ''}`}
                                onClick={() => setSelectedClass(parseInt(cls))}
                              >
                                Class {cls}
                              </button>
                            ))}
                          </div>
                          <div className="syllabus-content mt-4">
                            {(() => {
                              const syllabusData = selectedOly.id === 'mso' ? msoSyllabus : mcooSyllabus;
                              const data = syllabusData[selectedClass];
                              if (!data) return null;
                              return (
                                <>
                                  <h5>{data.title}</h5>
                                  {Object.entries(data.subjects).map(([subject, topics]) => (
                                    <div key={subject} className="mt-4">
                                      <h6 style={{ color: 'var(--secondary-gold)', fontSize: '1.1rem', marginBottom: '10px' }}>{subject}</h6>
                                      <ul className="syllabus-list">
                                        {topics.map((topic, i) => (
                                          <li key={i} style={{ marginBottom: '8px' }}>
                                            {topic.includes(':') ? (
                                              <>
                                                <strong>{topic.split(':')[0]}:</strong>
                                                {topic.substring(topic.indexOf(':') + 1)}
                                              </>
                                            ) : (
                                              topic
                                            )}
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  ))}
                                </>
                              );
                            })()}
                          </div>
                        </>
                      ) : (
                        <div className="syllabus-content mt-4">
                          {selectedOly.syllabus ? (
                            <p>{selectedOly.syllabus}</p>
                          ) : (
                            <h5>Detailed syllabus for {selectedOly.title} will be uploaded soon.</h5>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  {activeTab === 'exam-details' && (
                    <div className="tab-pane">
                      <h4>Exam Details</h4>
                      
                      {selectedOly.id === 'mso' || selectedOly.id === 'mcoo' ? (
                        <>
                          <div className="class-selector mb-4">
                            {Object.keys(selectedOly.id === 'mso' ? msoExamDetails : mcooExamDetails).map(cls => (
                              <button
                                key={cls}
                                className={`class-btn ${selectedClass === parseInt(cls) ? 'active' : ''}`}
                                onClick={() => setSelectedClass(parseInt(cls))}
                              >
                                Class {cls}
                              </button>
                            ))}
                          </div>

                          <div className="exam-details-content mt-4">
                            {(() => {
                              const examData = selectedOly.id === 'mso' ? msoExamDetails : mcooExamDetails;
                              const data = examData[selectedClass];
                              if (!data) return null;
                              return (
                                <>
                                  <div className="award-stage">
                                    <h5>Stage 1 Exam Details</h5>
                                    <ul>
                                      <li style={{ marginBottom: '8px' }}><strong>Sections & Questions:</strong> {data.stage1.sections}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Duration:</strong> {data.stage1.duration}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Question Type:</strong> {data.stage1.questionType}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Marking Scheme:</strong> {data.stage1.markingScheme}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Venue:</strong> {data.stage1.venue}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Mode:</strong> {data.stage1.mode}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Syllabus:</strong> {data.stage1.syllabus}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Language:</strong> {data.stage1.language}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Technical Instructions:</strong> {data.stage1.techInstructions}</li>
                                    </ul>
                                  </div>
                                  <div className="award-stage mt-4">
                                    <h5>Stage 2 Exam Details</h5>
                                    <ul>
                                      <li style={{ marginBottom: '8px' }}><strong>Sections & Questions:</strong> {data.stage2.sections}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Duration:</strong> {data.stage2.duration}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Question Type:</strong> {data.stage2.questionType}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Marking Scheme:</strong> {data.stage2.markingScheme}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Venue:</strong> {data.stage2.venue}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Mode:</strong> {data.stage2.mode}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Syllabus:</strong> {data.stage2.syllabus}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Language:</strong> {data.stage2.language}</li>
                                      <li style={{ marginBottom: '8px' }}><strong>Technical Instructions:</strong> {data.stage2.techInstructions}</li>
                                    </ul>
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                        </>
                      ) : (
                        <div className="award-stage mt-4">
                          {selectedOly.exam_details ? (
                            <p>{selectedOly.exam_details}</p>
                          ) : (
                            <h5>Detailed exam structure and format for {selectedOly.title} will be uploaded soon.</h5>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  {activeTab === 'awards' && (
                    <div className="tab-pane">
                      <h4>Awards and Deliverables</h4>
                      <div className="award-stage">
                        <h5>Stage 1: School Level Rewards</h5>
                        <ul>
                          {universalData.awards.stage1.map((item, idx) => <li key={idx} style={{ marginBottom: '8px' }}>{item}</li>)}
                        </ul>
                      </div>
                      <div className="award-stage mt-4">
                        <h5>Stage 2: District Level Rewards (For Students)</h5>
                        <ul>
                          {universalData.awards.stage2.map((item, idx) => <li key={idx} style={{ marginBottom: '8px' }}>{item}</li>)}
                        </ul>
                      </div>
                      <div className="award-stage mt-4">
                        <h5>Rewards to Schools</h5>
                        <ul>
                          {universalData.awards.schools.map((item, idx) => <li key={idx} style={{ marginBottom: '8px' }}>{item}</li>)}
                        </ul>
                      </div>
                    </div>
                  )}

                  {activeTab === 'register' && (
                    <div className="tab-pane">
                      <h4>Registration Form</h4>
                      <div className="registration-form">
                        <div className="reg-form-grid">
                          <div className="form-group">
                            <label htmlFor="firstName" className="form-label">First Name *</label>
                            <input type="text" id="firstName" autoComplete="given-name" value={formData.firstName || ''} onChange={handleChange} required className="form-input" />
                          </div>
                          <div className="form-group">
                            <label htmlFor="lastName" className="form-label">Last Name *</label>
                            <input type="text" id="lastName" autoComplete="family-name" value={formData.lastName || ''} onChange={handleChange} required className="form-input" />
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="email" className="form-label">Email Address *</label>
                          <input type="email" id="email" autoComplete="email" value={formData.email || ''} onChange={handleChange} required className="form-input" />
                          <small className="form-hint">Please ensure you provide an active and correct email address. We will send your Admit Card and other details to this email.</small>
                        </div>
                        <div className="form-group">
                          <label htmlFor="phone" className="form-label">Phone Number *</label>
                          <input type="tel" id="phone" autoComplete="tel" value={formData.phone || ''} onChange={handleChange} required className="form-input" />
                        </div>
                        
                        <div className="form-group">
                          <label htmlFor="classGrade" className="form-label">Class *</label>
                          <select id="classGrade" value={formData.classGrade || ''} onChange={handleChange} required className="form-input">
                            <option value="">-- Select Class --</option>
                            {selectedOly?.id === 'mcoo' ? (
                                <>
                                  <option value="11">Class 11</option>
                                  <option value="12">Class 12</option>
                                </>
                            ) : ['mso', 'mho', 'meo'].includes(selectedOly?.id) ? (
                                <>
                                  <option value="7">Class 7</option>
                                  <option value="8">Class 8</option>
                                  <option value="9">Class 9</option>
                                  <option value="10">Class 10</option>
                                  <option value="11">Class 11</option>
                                  <option value="12">Class 12</option>
                                </>
                            ) : (
                                <>
                                  <option value="7">Class 7</option>
                                  <option value="8">Class 8</option>
                                  <option value="9">Class 9</option>
                                  <option value="10">Class 10</option>
                                </>
                            )}
                          </select>
                        </div>

                        <div className="form-group">
                          <label htmlFor="schoolName" className="form-label">Select School *</label>
                          <select id="schoolName" value={formData.schoolName || ''} onChange={handleChange} required className="form-input">
                            <option value="">-- Select School --</option>
                            {MATHURA_SCHOOLS.map(school => <option key={school} value={school}>{school}</option>)}
                          </select>
                        </div>

                        {formData.schoolName === 'Other' && (
                          <div className="form-group">
                            <label className="form-label">Enter Your School Name *</label>
                            <input type="text" id="customSchoolName" value={formData.customSchoolName || ''} onChange={handleChange} required className="form-input" placeholder="Type your school name here..." />
                          </div>
                        )}

                        <input type="text" id="website_url" value={formData.website_url || ''} onChange={handleChange} style={{ display: 'none' }} tabIndex="-1" autoComplete="off" />

                        <ReCAPTCHA 
                          sitekey={import.meta.env.VITE_RECAPTCHA_SITE_KEY || '6LfkRKstAAAAAKaXSZjjig5Ad3e-riGiqR04GWFk'}
                          onChange={(token) => {
                              setCaptchaVerified(true);
                              updateFormData({ captchaToken: token });
                          }} 
                          onExpired={() => {
                              setCaptchaVerified(false);
                              updateFormData({ captchaToken: '' });
                          }}
                          style={{ marginTop: '1.5rem', display: 'flex', justifyContent: 'center' }}
                        />

                        {error && <div className="error-alert" style={{ marginTop: '1rem', color: 'red' }}><AlertCircle size={16} style={{ display: 'inline', verticalAlign: 'text-bottom' }} /> {error}</div>}

                        <button type="button" onClick={handleSubmit} className="btn btn-primary" disabled={isSubmitting} style={{ marginTop: '1.5rem', width: '100%' }}>
                          {isSubmitting ? 'Initializing...' : `Register Now (₹125)`}
                        </button>
                        
                        <div className="secure-badge" style={{ marginTop: '15px', textAlign: 'center', fontSize: '13px', color: '#666', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                          <ShieldCheck size={16} color="#4caf50" />
                          100% Secure Payments via Razorpay & Cashfree
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>

            {!isSubmitted && activeTab !== 'register' && (
              <div className="modal-footer">
                {selectedOly.isOpen ? (
                  <button className="btn btn-primary" onClick={handleProceedToRegistration}>Proceed to Registration</button>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <span style={{ color: 'var(--secondary-gold)', fontWeight: 'bold' }}>Registrations Opening Soon!</span>
                    <button className="btn btn-primary" disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>Proceed to Registration</button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Gateway Selector Modal */}
      {showGatewaySelector && (
        <div className="modal-overlay" onClick={() => setShowGatewaySelector(false)}>
          <div className="modal-content gateway-modal" onClick={e => e.stopPropagation()}>
             <button className="modal-close" onClick={() => setShowGatewaySelector(false)}><X size={24} /></button>
             <h2 style={{ marginBottom: '1.5rem' }}>Select Payment Gateway</h2>
             <p style={{ marginBottom: '2rem' }}>Choose your preferred secure payment method.</p>
             
             <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <button 
                  onClick={() => processPayment('cashfree')}
                  className="gateway-btn cashfree"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 30" style={{ height: '24px' }}>
                    <polygon points="12,4 20,12 12,20 4,12" fill="#3D3270" />
                    <polygon points="18,10 26,18 18,26 10,18" fill="#F37021" />
                    <text x="32" y="20" fontFamily="Arial, sans-serif" fontSize="18" fontWeight="800" fill="#3D3270" letterSpacing="-0.5">cashfree</text>
                  </svg>
                  <span>Pay with Cashfree</span>
                </button>
                
                <button 
                  onClick={() => processPayment('razorpay')}
                  className="gateway-btn razorpay"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}
                >
                  <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NDAiIGhlaWdodD0iNjQwIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiMzMzk1RkYiIGQ9Ik0yOTkuNiAyNjIuN2wtMTUuNyA1OCA5MC01OC4zLTU5IDIyMGg2MGw4Ny0zMjUiLz48cGF0aCBmaWxsPSIjMDcyNjU0IiBkPSJNMjAyLjYgMzkwbC0yNC44IDkyLjRoMTIyLjdsNTAuMi0xODgtMTQ4IDk1LjUiLz48L2c+PC9zdmc+" alt="Razorpay" style={{ height: '24px' }} />
                  <span>Pay with Razorpay</span>
                </button>
             </div>
          </div>
        </div>
      )}
    </div>
  );
}


